import { render, staticRenderFns } from "./ssoChartWidget.vue?vue&type=template&id=ba64af12&"
import script from "./ssoChartWidget.vue?vue&type=script&lang=js&"
export * from "./ssoChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\TeamCity\\Edison.Sso\\Dashboard\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba64af12')) {
      api.createRecord('ba64af12', component.options)
    } else {
      api.reload('ba64af12', component.options)
    }
    module.hot.accept("./ssoChartWidget.vue?vue&type=template&id=ba64af12&", function () {
      api.rerender('ba64af12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "v-components/widgets/ssoChartWidget.vue"
export default component.exports